import * as tslib_1 from "tslib";
import { Configuration, HttpClientCustom } from '../../../shared';
import { BiUrls } from '../../biUrls';
import { Observable } from 'rxjs/Rx';
var MDMService = /** @class */ (function () {
    function MDMService(mdmService, _global) {
        this.mdmService = mdmService;
        this._global = _global;
        this.base_url = this._global.get('EPMS_BASE_URL') + 'v1/';
        this.pageAuthList = [];
        this.roles = [];
        this.isBIAdmin = false;
        this.roleId = [];
    }
    MDMService.prototype.onStartUp = function (path) {
        console.log('ON STARTUP---SERVICE');
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        var objectList = [];
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '/';
            self.mdmService.get(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.save = function (path, objectData) {
        console.log('ON SAVE---SERVICE');
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '/';
            self.mdmService.post(url, objectData).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.search = function (path, searchUrlPath, regexData, page, size) {
        console.log('ON SEARCH --- SERVICE');
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        var url;
        if (page == undefined && size == undefined) {
            url = self.base_url + path + searchUrlPath + regexData;
        }
        else {
            url = self.base_url + path + searchUrlPath + regexData + '&page=' + page + '&size=' + size;
        }
        return new Promise(function (resolve, reject) {
            self.mdmService.post(url, null).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.search1 = function (path, searchUrlPath, regexData) {
        var self = this;
        // let path1 = path;
        // path = self.updatePath(path1);
        var url = self.base_url + path + searchUrlPath + regexData;
        // self.isBIAdmin = false;
        return Observable.create(function (observer) {
            var obs = Observable.forkJoin([self.mdmService.post(url, null)]);
            obs.subscribe(function (response) {
                if (response[0] != undefined && response[0].success && response[0].data != undefined) {
                    observer.next(response[0].data);
                }
                else {
                    observer.next([]);
                }
                observer.complete();
            });
        });
    };
    MDMService.prototype.bulkUpload = function (path, bulkUploadUrlPath, formData) {
        console.log('ON BULK UPLOAD --- SERVICE');
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + bulkUploadUrlPath;
            self.mdmService.filePost(url, formData).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.delete = function (path, id) {
        console.log('ON DELETE---SERVICE');
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '/' + id;
            self.mdmService.delete(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.deleteModel = function (path, cubeId, recFormatId, dataSourceId) {
        console.log('ON DELETE---SERVICE');
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '?cId=' + cubeId + "&rId=" + recFormatId + "&dId=" + dataSourceId;
            self.mdmService.delete(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.update = function (path, objectData) {
        console.log('ON EDIT---SERVICE');
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '/';
            self.mdmService.put(url, objectData).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.testConnection = function (path, DSdata) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path;
            self.mdmService.post(url, DSdata).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.getObjectById = function (path) {
        var object = {};
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path;
            self.mdmService.get(url).subscribe(function (res) {
                // object = res;
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.syncDataSource = function (id) {
        var _this = this;
        var self = this;
        var path1 = BiUrls.SYNC_DATASOURCE + id;
        var path = self.updatePath(path1);
        path = self.base_url + path;
        return new Promise(function (resolve, reject) {
            _this.mdmService.get(path).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.syncAllRecordFormatsInDataSource = function (id) {
        var _this = this;
        var self = this;
        var path1 = BiUrls.SYNC_ALL_RF_DATASOURCE + id;
        var path = self.updatePath(path1);
        path = self.base_url + path;
        return new Promise(function (resolve, reject) {
            _this.mdmService.get(path).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.syncRecordFormat = function (id) {
        var _this = this;
        var self = this;
        var path1 = BiUrls.SYNC_RECORD_FORMAT + id;
        var path = self.updatePath(path1);
        path = self.base_url + path;
        return new Promise(function (resolve, reject) {
            _this.mdmService.get(path).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.updatePath = function (path) {
        var self = this;
        if (self.isBIAdmin) {
            return BiUrls.BIADMIN + '/' + path;
        }
        else {
            return path;
        }
    };
    MDMService.prototype.getDataByPage = function (path, page, size) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '?page=' + page + '&size=' + size;
            self.mdmService.get(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.getRoleData = function (url) {
        var self = this;
        return new Promise(function (resolve) {
            self.mdmService.get(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.getDataById = function (path, id) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '/' + id;
            self.mdmService.get(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.getDimensionByMeasureId = function (path, id) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + id;
            self.mdmService.get(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.loadPageAuthorizations = function (path, empIdList, pageId) {
        console.log('ON LOAD PAGE AUTHORIZATION SERVICE ----------');
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        self.pageAuthList = [];
        var url = self.base_url + path + pageId;
        return new Promise(function (resolve, reject) {
            self.mdmService.post(url, empIdList).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                resolve(err);
                console.log(err);
            });
        });
    };
    MDMService.prototype.loadRoleAuthorizations = function (url, roleId) {
        var self = this;
        return new Promise(function (resolve, reject) {
            self.mdmService.post(url, roleId).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                resolve(err);
                console.log(err);
            });
        });
    };
    MDMService.prototype.getRoleWidgets = function (url, roleIdList) {
        var self = this;
        return new Promise(function (resolve, reject) {
            self.mdmService.post(url, roleIdList).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                resolve(err);
                console.log(err);
            });
        });
    };
    MDMService.prototype.setRoleId = function (id, name) {
        this.roleId.push(id);
        this.roleName = name;
    };
    MDMService.prototype.onSaveOrUpdate = function (path, pageAuthList) {
        console.log('ON SAVE OR UPDATE SERVICE ------------------');
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        var toBeAdded = [];
        var toBeUpdated = [];
        var url = self.base_url + path;
        return new Promise(function (resolve, reject) {
            self.mdmService.post(url, pageAuthList).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                //resolve(err);
                reject(err);
                console.log(err);
            });
        });
    };
    MDMService.prototype.onUpdateRoleAuth = function (url, psIdList) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var self;
            return tslib_1.__generator(this, function (_a) {
                self = this;
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        self.mdmService.post(url, psIdList).subscribe(function (res) {
                            if (res) {
                                resolve(res);
                            }
                        }, function (err) {
                            reject(err);
                            console.log(err);
                        });
                    })];
            });
        });
    };
    MDMService.prototype.getDimLevelValues = function (dimLvlObj) {
        var self = this;
        var path1 = String('../' + BiUrls.GET_DIM_LVL_VALUE);
        var path = self.updatePath(path1);
        path = self.base_url + path;
        console.log('GET DIMENSION LEVEL VALUE SERVICE .....');
        return new Promise(function (resolve, reject) {
            self.mdmService.post(path, dimLvlObj).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                reject(err);
            });
        });
    };
    MDMService.prototype.deleteEmpOrgDimRel = function (path, data) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        var url = self.base_url + path;
        return new Promise(function (resolve, reject) {
            self.mdmService.post(url, data).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                reject(err);
            });
        });
    };
    MDMService.prototype.roleCheck = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var self, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        console.log('ROLE CHECK SERVICE ......');
                        self = this;
                        _a = self;
                        return [4 /*yield*/, self.getObjectById(BiUrls.GET_OPERATIONS_FOR_USER)];
                    case 1:
                        _a.roles = _b.sent();
                        self.isBIAdmin = self.roles.includes('ROLE_BI_ADMIN');
                        console.log('BI-ADMIN : ' + self.isBIAdmin);
                        return [2 /*return*/];
                }
            });
        });
    };
    MDMService.prototype.getAll = function (path) {
        var self = this;
        path = self.updatePath(path);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '/';
            self.mdmService.get(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.uploadFileToDrill = function (path, formData, dataSource) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '?dataSourceId=' + dataSource;
            self.mdmService.filePost(url, formData).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.clearCache = function (path) {
        var self = this;
        path = self.updatePath(path);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path;
            self.mdmService.put(url, null).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.reUploadDrillFile = function (path, formData, dataSource) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '?recordFormatId=' + dataSource;
            self.mdmService.filePost(url, formData).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.getEmployee = function (searchData) {
        var _this = this;
        return new Promise(function (resolve) {
            try {
                var self_1 = _this;
                var url = self_1.base_url + "webAdmin/employee";
                //let path1 = "page/getSearchedEmp";
                //let path = self.updatePath(path1);
                //let url = self.base_url + path;
                //let url = self.base_url + "biAdmin/empSearch";
                self_1.mdmService.post(url, searchData).subscribe(function (result) {
                    resolve(result);
                });
            }
            catch (e) {
                console.log("getAllEmployeeData error catch", e);
            }
        });
    };
    MDMService.prototype.uploadFileToDrillForWizard = function (path, formData, dataSource, uploadType) {
        var type = uploadType == true ? '?cubeId=' : '?dataSourceId=';
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + type + dataSource;
            self.mdmService.filePost(url, formData).subscribe(function (res) {
                resolve(res instanceof Object ? res : JSON.parse(res));
            }, function (err) {
                console.log(err);
                reject(err);
            });
        });
    };
    MDMService.prototype.syncPrestoData = function (path, cubeId) {
        var type = '?cubeId=';
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + type + cubeId;
            self.mdmService.post(url, null).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                reject(err);
            });
        });
    };
    MDMService.prototype.uploadDataSourceForPresto = function (path, dataSource) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + dataSource;
            self.mdmService.get(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.createAnalyticalModelPresto = function (path, rfData) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path;
            self.mdmService.post(url, rfData).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.saveFileForDesigner = function (path, cubeData) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path;
            self.mdmService.post(url, cubeData).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.analyticalModelPreview = function (path, ModelData) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve) {
            var url = self.base_url + path;
            self.mdmService.post(url, ModelData).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.syncCacheConfig = function (path) {
        var self = this;
        var path1 = BiUrls.CACHE + path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path;
            self.mdmService.put(url, null).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.flushCacheConfig = function (path) {
        var self = this;
        var path1 = BiUrls.CACHE + path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path;
            self.mdmService.delete(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.dimensionData = function (dimensionData) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = _this.base_url + 'bi/adhoc/dimension';
            _this.mdmService.post(url, dimensionData).toPromise().then(function (res) {
                resolve(res);
            }, function (err) {
                console.error(err);
                reject(err);
            });
        });
    };
    MDMService.prototype.getProgress = function (token, path) {
        var _this = this;
        var url = 'page/bulkUpload/' + path + token;
        url = this.updatePath(url);
        url = this.base_url + url;
        return new Promise(function (resolve, reject) {
            _this.mdmService.get(url).toPromise().then(function (res) {
                resolve(res);
            }, function (err) {
                console.error(err);
                reject(err);
            });
        });
    };
    MDMService.prototype.getTimeDimension = function (measureIdList) {
        var self = this;
        return new Promise(function (resolve, reject) {
            var url = self.base_url + 'bi/dimension/getDim?isDimTime=true';
            self.mdmService.post(url, measureIdList).toPromise().then(function (res) {
                resolve(res);
            }), function (err) {
                reject(err);
            };
        });
    };
    MDMService.prototype.createDataPoint = function (path, oData, type) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path;
            self.mdmService[type](url, oData).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.getAllDataPointsByDSid = function (path, id) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '/' + id;
            self.mdmService.get(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.getRFfromDataPointId = function (path, id) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '?dataPointId=' + id + '&createTemporary=true';
            self.mdmService.get(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                reject(err);
            });
        });
    };
    MDMService.prototype.createAnalyticalModelOdata = function (path, rfList, id) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '?dataPointId=' + id + '&createTemporary=true';
            self.mdmService.post(url, rfList).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.saveAnalyticalModelOdata = function (path, Odata) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path;
            self.mdmService.post(url, Odata).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.reBuildDashboardSnaphot = function (path) {
        var self = this;
        path = self.updatePath(path);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path;
            self.mdmService.post(url, null).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.ERROR = 'error';
    MDMService.SUCCESS = 'success';
    MDMService.WARNING = 'warning';
    return MDMService;
}());
export { MDMService };



// WEBPACK FOOTER //
// ./src/app/bi/admin/services/mdmService.service.ts.pre-build-optimizer.js